export default __webpack_public_path__ + "static/media/knowledge3.07928f7f.png";